import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { UserDataKey } from '@app/client/common/structs/user/user-data';
import { callGetUserData } from '@app/client/resources/admin/users';
import { PathParams } from '@app/routes/types';

export const useGetUserFeatures = () => {
    const { [PathParams.Id]: userId } = useParams();
    const cache = ['user-feature-cache'];

    return useQuery({
        queryKey: cache,
        queryFn: ({ signal }) =>
            callGetUserData({ key: UserDataKey.FrontendFeatureFlags, id: userId, settings: { signal } }),
        enabled: Boolean(userId),
        placeholderData: keepPreviousData,
        retry: true,
    });
};
